import $ from 'jquery';

export function initHeaderScrolledClass() {
    const $header = $('.site-header');
    if ($header.length === 0) return;

    let ticking = false;

    const update = () => {
        ticking = false;
        const scrolled = window.scrollY > 0;
        $header.toggleClass('scrolled', scrolled);
    };

    const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    update();
}

export function addTopPaddingMain() {
    const $main = $('.site-main');
    const $header = $('.site-header');
    if ($main.length === 0 || $header.length === 0) return;
    const headerHeight = $header.outerHeight();
    $main.css('padding-top', headerHeight);
}

function getScrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

function getHeaderOffset() {
    const header = document.querySelector('.site-header');
    return header ? header.getBoundingClientRect().height : 0;
}

function scrollToElement(target, { behavior = getScrollBehavior() } = {}) {
    if (!target) return false;

    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior });
    return true;
}

function scrollToHash(hash, options) {
    const id = decodeURIComponent(String(hash).replace(/^#/, ''));
    if (!id) return false;
    return scrollToElement(document.getElementById(id), options);
}

function isSamePageAnchor(link) {
    if (!link.hash || link.hash === '#') return false;
    return link.pathname === window.location.pathname && link.search === window.location.search;
}

export function anchorScroll() {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href*="#"]');
        if (!link || !isSamePageAnchor(link)) return;

        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;

        event.preventDefault();
        scrollToElement(target, { behavior: getScrollBehavior() });
        history.pushState(null, '', link.hash);
    });

    window.addEventListener('hashchange', () => {
        scrollToHash(window.location.hash, { behavior: getScrollBehavior() });
    });

    if (!window.location.hash) return;

    history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);

    const scrollOnLoad = () => {
        requestAnimationFrame(() => {
            scrollToHash(window.location.hash, { behavior: getScrollBehavior() });
        });
    };

    if (document.readyState === 'complete') {
        scrollOnLoad();
    } else {
        window.addEventListener('load', scrollOnLoad, { once: true });
    }
}

$(initHeaderScrolledClass);
$(addTopPaddingMain);
$(anchorScroll);